<template>
  <v-card class="primary">
    <div
      :class="$vuetify.breakpoint.mobile ? 'flex-column' : 'justify-space-between'"
      class="d-flex pa-4"
    >
      <div
        :class="$vuetify.breakpoint.mobile ? 'flex-column' : ''"
        class="d-flex"
      >
        <div
          :class="$vuetify.breakpoint.mobile ? 'mb-3' : 'mr-10 align-self-center'"
          class="white--text titre-h3 mt-1"
        >
          {{ graineRs3.libelle | capitalize }}
        </div>
        <div
          :class="$vuetify.breakpoint.mobile ? 'flex-column' : ''"
          class="d-flex"
        >
          <div
            :class="$vuetify.breakpoint.mobile ? '' : 'mr-10'"
            class="d-flex"
          >
            <span
              class="white--text titre-h1 mr-2 align-self-center"
            >{{ nbContrats }}</span>
            <span
              class="white--text intro align-self-center"
            >contrat{{ nbContrats > 1 ? 's' : '' }}</span>
          </div>
          <div
            v-if="resumesContrats.length"
            class="d-flex"
          >
            <span
              class="white--text intro align-self-center"
            >Poids total</span>
            <span
              class="white--text titre-h1 ml-2 align-self-center"
            >{{ totalPoidsContractualise }} t</span>
          </div>
        </div>
      </div>
      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <div
            :class="$vuetify.breakpoint.mobile ? 'mt-3 d-flex justify-center' : ''"
            v-on="on"
          >
            <AgrButton
              :disabled="!hasReglementCampagne || loadingReglementCampagne"
              target="_blank"
              text
              @click="onDownloadReglementCampagne"
            >
              <BaseLoader
                v-if="loadingReglementCampagne"
              />
              <v-img
                v-else
                class="ma-2 icon"
                color="white"
                src="@/assets/download/white-tray-arrow-down.svg"
              />
              <span
                :class="$vuetify.breakpoint.mobile ? 'mention' : 'action'"
                class="text-truncate white--text "
              >Règlement de campagne (PDF)</span>
            </AgrButton>
          </div>
        </template>
        {{ tooltipReglementCampagne }}
      </v-tooltip>
    </div>
  </v-card>
</template>

<script>
import {AgrButton} from '@agrial/ui'
import BaseLoader from '@/components/common/base-loader.vue'
import {round} from 'lodash'

export default {
  name: 'ResumeDetailContrats',
  components: {AgrButton, BaseLoader},
  props: {
    resumesContrats: {
      type: Array,
      required: true
    },
    graineRs3: {
      type: Object,
      required: true
    },
    hasReglementCampagne: {
      type: Boolean,
      default: false
    },
    loadingReglementCampagne: {
      type: Boolean,
      default: false
    },
    tooltipReglementCampagne: {
      type: String,
      default: null
    },
  },

  computed: {
    totalPoidsContractualise () {
      let total = this.resumesContrats
        .map(contrat => contrat.quantiteCibleEnKg)
        .filter(q => q!=null)
        .reduce((a, b) => a + b, 0)
        total += this.resumesContrats
        .map(contrat => contrat.quantiteTresoMoissonEngageAFixerEnKg + contrat.quantiteTresoMoissonLivreeSansFixationEnKg - contrat.quantiteTresoMoissonEnAttenteEnKg)
        .reduce((a, b) => a + b, 0)
      
      return round(total / 1000, 3).toString().replace(/\./g, ',')
    },
    nbContrats () {
      return this.resumesContrats.length
    }
  },
  methods: {
    onDownloadReglementCampagne () {
      this.$emit('download-reglement-campagne')
    }
  }
}
</script>
<style lang="scss" scoped>
.icon {
  width: 1.7em;
}

</style>
